import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';

// Native <select> estilizado. Aceita `options` ou children <option>.
const Select = forwardRef(
  (
    {
      label,
      options,
      value,
      onChange,
      placeholder,
      error,
      required = false,
      disabled = false,
      helpText,
      className = '',
      children,
      id,
      ...props
    },
    ref
  ) => {
    const selectId = id || (label ? `select-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
    return (
      <div className="w-full">
        {label && (
          <label htmlFor={selectId} className="block text-sm font-medium text-app-text mb-1">
            {label}
            {required && <span className="text-error ml-1">*</span>}
          </label>
        )}
        <div className="relative">
          <select
            ref={ref}
            id={selectId}
            value={value ?? ''}
            onChange={onChange}
            disabled={disabled}
            required={required}
            aria-invalid={!!error}
            className={`
              w-full pl-4 pr-10 py-2 border rounded-lg text-app-text bg-white appearance-none
              focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent
              disabled:bg-app-surface disabled:cursor-not-allowed
              ${error ? 'border-error' : 'border-gray-300'}
              ${className}
            `
              .trim()
              .replace(/\s+/g, ' ')}
            {...props}
          >
            {placeholder && (
              <option value="" disabled>
                {placeholder}
              </option>
            )}
            {options
              ? options.map((opt) => (
                  <option key={opt.value} value={opt.value} disabled={opt.disabled}>
                    {opt.label}
                  </option>
                ))
              : children}
          </select>
          <ChevronDown
            size={18}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-app-text-secondary pointer-events-none"
          />
        </div>
        {error && <p className="mt-1 text-sm text-error">{error}</p>}
        {helpText && !error && (
          <p className="mt-1 text-xs text-app-text-secondary">{helpText}</p>
        )}
      </div>
    );
  }
);

Select.displayName = 'Select';

export default Select;
